// extracted by mini-css-extract-plugin
export default {"result":"Result_result__Sp7wD"};